import * as React from 'react';
import { connect } from 'react-redux';
import * as LoginActions from '../../actions/LoginActions';
import type { IAsynchronousAction, IExternalState } from '../../appstate';
import type { IConnectedComponentProps } from '../../domain';
import type { IToastMessage } from '../../helpers/Toastr';
import { toastr } from '../../helpers/Toastr';
import SignInModule from './SignInModule';

export interface ILoginProps {
	signingIn: IAsynchronousAction;
	unknownError: boolean;
}
interface IConnectedLoginProps extends ILoginProps, IConnectedComponentProps {}

export class Login extends React.Component<IConnectedLoginProps> {
	public componentDidMount() {
		setTimeout(() => {
			const wasAutoLoggedOut =
				((LoginActions.getParameterByName('auto') || '').toUpperCase() ||
					'FALSE') === 'TRUE';
			if (wasAutoLoggedOut) {
				const toast: IToastMessage = {
					body: 'You have been automatically signed out due to inactivity.',
					options: {
						okText: 'OK',
						disableCancel: true,
					},
				};
				toastr.confirm(toast);
			}
		}, 333); // throttle to allow content to load before blocking.
	}

	public render() {
		const { signingIn, unknownError } = this.props;
		return (
			<SignInModule
				signingIn={signingIn}
				signIn={this.signIn}
				unknownError={unknownError}
			/>
		);
	}

	private signIn = (username: string, password: string) => {
		const { dispatch } = this.props;
		dispatch(LoginActions.signIn(username, password));
	};
}

const mapStateToProps = (state: IExternalState): ILoginProps => {
	return {
		signingIn: state.login.signingIn,
		unknownError: state.login.unknownError,
	};
};

export default connect(mapStateToProps)(Login);
